import React, {useContext} from "react";
import parse from "html-react-parser";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//show estimate notes
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <>
            <div className='border border-dark px-sm-2 mt-2'>
                {IV2_PageDetails.ImportantNoticeText ?
                    <>
                        <b>IMPORTANT NOTICE : </b>{parse(`${IV2_PageDetails.ImportantNoticeText}`)} <br/><br/>
                    </> : "" }
                {IV2_PageDetails.DifficultAccessText ?
                    <>
                        <b>{IV2_PageDetails.difficult_access_exception_heading} : </b>
                        {parse(IV2_PageDetails.DifficultAccessText)} <br/><br/>
                    </> : "" }
                {IV2_PageDetails.shipmentSetting ?
                    <>
                        <b>SHIPMENT TEXT : </b>
                        {IV2_PageDetails.ShipmentText ?
                            <>
                                {IV2_PageDetails.ShipmentText}
                            </> : ""}
                    </> : "" }
            </div>
        <div className='border border-dark px-sm-2 mt-2'>
            {IV2_PageDetails.EstNotes ?  parse(`${IV2_PageDetails.EstNotes}`) : ""}
        </div>
        </>
    )
}